// THIS CODE IS GENERATED. DO NOT MODIFY
/* istanbul ignore next */
(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csAccountsReceivableInvoiceV1', ['bmHttpUtils', 'bluemoon.components.session']).service('csAccountsReceivableInvoiceV1',
        ['$http', 'bmHttpUtils', 'AuthenticatedSessionData',
        function($http, bmHttpUtils, authenticatedSessionData) {
            return {
                putCalculatorInvoiceAmounts: function(params, suppressErrors) {
                    var url = '/api/core/v1/accounts-receivable/calculators/invoice-amounts';

                    var query = {
                        'includeReadOnlyDistributions': params['includeReadOnlyDistributions']
                    };
                    var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                        $http({url: url, method: 'POST', params: query, headers: {}, data: strippedData }), suppressErrors);
                },

                postCalculatorInvoiceQuickBillDistribute: function(params, suppressErrors) {
                    var url = '/api/core/v1/accounts-receivable/calculators/invoice-quick-bill-distribute';
                    var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                },

                postCalculatorInvoiceQuickBillInitialize: function(params, suppressErrors) {
                    var url = '/api/core/v1/accounts-receivable/calculators/invoice-quick-bill-initialize';
                    var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                },

                postCalculatorInvoiceQuickBillUpdate: function(params, suppressErrors) {
                    var url = '/api/core/v1/accounts-receivable/calculators/invoice-quick-bill-update';
                    var strippedData = bmHttpUtils.getStrippedObject(params['dto'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['dto'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                },

                putCalculatorInvoiceUnbill: function(params, suppressErrors) {
                    var url = '/api/core/v1/accounts-receivable/calculators/invoice-unbill';
                    var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                },

                postCalculatorInvoiceByClient: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-by-client';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postCalculatorInvoiceByClientFixedFeeBillingTemplate: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-by-client-fixed-fee-billing-template';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postInvoiceByDate: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-by-date';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'recalculateDueDate': paramsCopy['recalculateDueDate']
                        };
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: query, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postCalculatorInvoiceByEngagement: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-by-engagement';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postCalculatorInvoiceByFixedFeeFromInvoice: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-by-fixed-fee-from-invoice';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postCalculatorInvoiceByProject: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-by-project';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                getInvoice: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-editor/{accountsReceivableId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{accountsReceivableId}/g, paramsCopy['accountsReceivableId']);
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: {}, headers: {} }), suppressErrors);
                    });
                },

                postCalculatorInvoiceReversal: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-reversal';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postCalculatorInvoiceCalculateTax: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/calculators/invoice-tax';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postAdjustmentInvoice: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/invoice/as-adjustment';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postInvoiceByClient: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/invoice/by-client';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postInvoiceByEngagement: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/invoice/by-engagement';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                postInvoiceByProject: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/invoice/by-project';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                getInvoiceDetailDefault: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/accounts-receivable/invoice-detail/default';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'timeAndExpenseTypeId': paramsCopy['timeAndExpenseTypeId'],
                            'activityId': paramsCopy['activityId'],
                            'clientId': paramsCopy['clientId']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                }

            };
        }]);
}(window.angular));
